<template>
    <router-link v-if="isUserLoggedIn" :to="{ name: 'logout' }" class="text-center uppercase text-sm">
        <h5 class="block md:hidden leading-none m-0">Log<br>Out</h5>
        <p class="hidden md:block leading-none m-0">Log<br>Out</p>
    </router-link>
</template>

<script>
export default {
    name: 'LogInLinkCanvasser',
    computed: {
        isUserLoggedIn: {
            get() {
                return this.$store.getters['auth/isUserLoggedIn'];
            },
        },
    },
};
</script>
